/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useGetChildUsersQuery } from "../../Redux/service/Users/Users";
import { filtrationcontext } from "../../context/Filtercontext";
import trans from "../../utils";
import Searchbar from "../Helpers/Searchbar/Searchbar";
import { InputSelect } from "../Helpers/Input/RefactoredInput";

export default function RequestsHead({ setFilter }) {
	const { setSearchQuery } = useContext(filtrationcontext);
	const inf = useSelector((state) => state.users.user);
	const { data } = useGetChildUsersQuery({ userId: inf?.id });

	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	const serviceOptions = [
		{ label: trans("electrical"), value: "electrical" },
		{ label: trans("air_conditioning"), value: "air_conditioning" },
	];

	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>

				<InputSelect
					placeholder={trans("Type")}
					options={serviceOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => setFilter((prev) => ({ ...prev, serviceType: e }))}
				/>
				<InputSelect
					placeholder={trans("users")}
					options={data?.data?.map((i) => ({
						label: i?.name,
						value: i?.id,
					}))}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => setFilter((prev) => ({ ...prev, userId: e }))}
				/>
			</div>
		</>
	);
}
